import { Capacitor } from '@capacitor/core';

/** Igaz a Capacitor által csomagolt natív alkalmazásban, weben mindig hamis. */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

/** Az iOS-specifikus natív képességek megkülönböztetése. */
export function isNativeIos(): boolean {
  return Capacitor.getPlatform() === 'ios';
}

/** Az Android-specifikus natív képességek megkülönböztetése. */
export function isNativeAndroid(): boolean {
  return Capacitor.getPlatform() === 'android';
}

/**
 * A PLATFORM KIÍRÁSA A GYÖKÉRELEMRE, HOGY A CSS IS LÁSSA.
 *
 * ⚠️ MÉRT HIBA javítása (2026-09-17). A dokk alsó távolsága a
 * `safe-area-inset-bottom`-ból jön, amiből iOS-en 26 px-t le kell vonni (a
 * home-indikátor alatt maradó üres sáv miatt) — Androidon viszont NEM, mert
 * ott ugyanaz az inset a gesztussávot jelenti: a levonás a dokkot pont bele-
 * és alátolta. A `env()` nem tudja megmondani, MELYIK platform adta az
 * értéket, ezért a megkülönböztetés csak innen jöhet.
 *
 * `data-platform`: `ios` · `android` · `web`.
 */
export function markPlatform(): void {
  document.documentElement.dataset.platform = Capacitor.getPlatform();
}
